var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7813 4.00415C7.95313 4.09796 5 6.94376 5 10.2586V18.4833C5 18.9524 5.61979 19.1713 5.98438 18.8586L6.89583 18.2644C7.11458 18.108 7.47917 18.1393 7.66146 18.3269L9.22917 19.8593C9.44792 20.0469 9.84896 20.0469 10.0677 19.8593L11.5625 18.4207C11.7813 18.2018 12.1823 18.2018 12.401 18.4207L13.8958 19.8593C14.1146 20.0469 14.5156 20.0469 14.7344 19.8593L16.3021 18.3269C16.4844 18.1393 16.849 18.108 17.0677 18.2644L17.9792 18.8586C18.3438 19.1713 19 18.9524 19 18.4833V9.97718C19 6.59976 15.7188 3.87906 11.7813 4.00415ZM9.66667 10.9779C9.01042 10.9779 8.5 10.5401 8.5 9.97718C8.5 9.44555 9.01042 8.97646 9.66667 8.97646C10.2865 8.97646 10.8333 9.44555 10.8333 9.97718C10.8333 10.5401 10.2865 10.9779 9.66667 10.9779ZM14.3333 10.9779C13.6771 10.9779 13.1667 10.5401 13.1667 9.97718C13.1667 9.44555 13.6771 8.97646 14.3333 8.97646C14.9531 8.97646 15.5 9.44555 15.5 9.97718C15.5 10.5401 14.9531 10.9779 14.3333 10.9779Z",
    fill: "#888891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.399d35ea32bd27d66db6758efce2ddce.svg";
export { ForwardRef as ReactComponent };